// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FloatingLanguageSwitcher_floatingContainer__Tu5Lm {
  position: fixed;
  bottom: 30px;
  left: 30px;
  z-index: 9999;
}

/* Main Button - with glow */
.FloatingLanguageSwitcher_mainBtn__lEM\\+c {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1a5f3f 0%, #0f4229 100%);
  color: white;
  border: none;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.4),
              0 0 20px rgba(26, 95, 63, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 10001;
}

.FloatingLanguageSwitcher_mainBtn__lEM\\+c:hover {
  background: linear-gradient(135deg, #0f4229 0%, #082917 100%);
  box-shadow: 0 6px 16px rgba(26, 95, 63, 0.5),
              0 0 30px rgba(26, 95, 63, 0.5),
              0 0 40px rgba(26, 95, 63, 0.3);
  transform: scale(1.08);
  cursor: pointer;
}

.FloatingLanguageSwitcher_mainBtn__lEM\\+c.FloatingLanguageSwitcher_open__pN0X0 {
  background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);
  transform: rotate(90deg);
  box-shadow: 0 4px 12px rgba(211, 47, 47, 0.4),
              0 0 20px rgba(211, 47, 47, 0.3);
}

.FloatingLanguageSwitcher_mainBtn__lEM\\+c.FloatingLanguageSwitcher_open__pN0X0:hover {
  background: linear-gradient(135deg, #b71c1c 0%, #8b0000 100%);
  box-shadow: 0 6px 16px rgba(211, 47, 47, 0.5),
              0 0 30px rgba(211, 47, 47, 0.5),
              0 0 40px rgba(211, 47, 47, 0.3);
  cursor: pointer;
}

/* Options Container */
.FloatingLanguageSwitcher_optionsContainer__hiPqs {
  position: absolute;
  bottom: 70px;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
  z-index: 1000;
}

.FloatingLanguageSwitcher_optionsContainer__hiPqs.FloatingLanguageSwitcher_visible__9i3Dn {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  pointer-events: all;
}

/* Option Buttons - ENHANCED with micro-interactions */
.FloatingLanguageSwitcher_optionBtn__459D3 {
  width: 120px;
  height: 48px;
  border-radius: 24px;
  background: white;
  border: 2px solid #1a5f3f;
  color: #1a5f3f;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1),
              0 0 0 rgba(26, 95, 63, 0);
  font-weight: 600;
  position: relative;
  overflow: hidden;
}

/* Animated background effect on hover (shimmer sweep) */
.FloatingLanguageSwitcher_optionBtn__459D3::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(26, 95, 63, 0.1) 50%, 
    transparent 100%);
  transition: left 0.5s ease;
  z-index: 0;
}

.FloatingLanguageSwitcher_optionBtn__459D3:hover::before {
  left: 100%;
}

.FloatingLanguageSwitcher_optionBtn__459D3:hover {
  background: rgba(26, 95, 63, 0.05);
  border-color: #0f4229;
  transform: translateX(8px) scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15),
              0 0 20px rgba(26, 95, 63, 0.3);
  cursor: pointer;
}

/* Animate the label on hover */
.FloatingLanguageSwitcher_optionBtn__459D3:hover .FloatingLanguageSwitcher_optionLabel__dsVoI {
  transform: translateX(-2px);
  color: #0f4229;
}

/* Animate the code on hover */
.FloatingLanguageSwitcher_optionBtn__459D3:hover .FloatingLanguageSwitcher_optionCode__fHWdV {
  transform: scale(1.15);
  opacity: 1;
}

.FloatingLanguageSwitcher_optionBtn__459D3.FloatingLanguageSwitcher_active__\\+dIA9 {
  background: linear-gradient(135deg, #1a5f3f 0%, #0f4229 100%);
  color: white;
  border-color: #1a5f3f;
  box-shadow: 0 2px 8px rgba(26, 95, 63, 0.3),
              0 0 15px rgba(26, 95, 63, 0.2);
}

/* Active state shouldn't show the sweep effect */
.FloatingLanguageSwitcher_optionBtn__459D3.FloatingLanguageSwitcher_active__\\+dIA9::before {
  display: none;
}

.FloatingLanguageSwitcher_optionBtn__459D3.FloatingLanguageSwitcher_active__\\+dIA9:hover {
  background: linear-gradient(135deg, #0f4229 0%, #082917 100%);
  border-color: #0f4229;
  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.4),
              0 0 25px rgba(26, 95, 63, 0.4);
  cursor: pointer;
  transform: translateX(8px) scale(1.05);
}

.FloatingLanguageSwitcher_optionLabel__dsVoI {
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

.FloatingLanguageSwitcher_optionCode__fHWdV {
  font-size: 12px;
  font-weight: 700;
  opacity: 0.8;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

/* Backdrop */
.FloatingLanguageSwitcher_backdrop__BS1rO {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 998;
  animation: FloatingLanguageSwitcher_fadeIn__8t7Aq 0.3s ease;
  cursor: pointer;
}

@keyframes FloatingLanguageSwitcher_fadeIn__8t7Aq {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Tablet Responsive */
@media (max-width: 1024px) {
  .FloatingLanguageSwitcher_floatingContainer__Tu5Lm {
    bottom: 25px;
    left: 25px;
  }

  .FloatingLanguageSwitcher_mainBtn__lEM\\+c {
    width: 52px;
    height: 52px;
    font-size: 15px;
  }

  .FloatingLanguageSwitcher_optionBtn__459D3 {
    width: 110px;
    height: 44px;
    padding: 0 14px;
  }

  .FloatingLanguageSwitcher_optionLabel__dsVoI {
    font-size: 13px;
  }

  .FloatingLanguageSwitcher_optionCode__fHWdV {
    font-size: 11px;
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .FloatingLanguageSwitcher_floatingContainer__Tu5Lm {
    bottom: 20px;
    left: 20px;
  }

  .FloatingLanguageSwitcher_mainBtn__lEM\\+c {
    width: 50px;
    height: 50px;
    font-size: 14px;
    box-shadow: 0 3px 10px rgba(26, 95, 63, 0.4),
                0 0 15px rgba(26, 95, 63, 0.25);
  }

  .FloatingLanguageSwitcher_mainBtn__lEM\\+c:hover {
    box-shadow: 0 4px 12px rgba(26, 95, 63, 0.5),
                0 0 25px rgba(26, 95, 63, 0.4);
  }

  .FloatingLanguageSwitcher_optionsContainer__hiPqs {
    bottom: 65px;
  }

  .FloatingLanguageSwitcher_optionBtn__459D3 {
    width: 105px;
    height: 42px;
    padding: 0 12px;
    border-radius: 21px;
  }

  .FloatingLanguageSwitcher_optionLabel__dsVoI {
    font-size: 12px;
  }

  .FloatingLanguageSwitcher_optionCode__fHWdV {
    font-size: 10px;
  }
}

/* Small Mobile */
@media (max-width: 480px) {
  .FloatingLanguageSwitcher_floatingContainer__Tu5Lm {
    bottom: 15px;
    left: 15px;
  }

  .FloatingLanguageSwitcher_mainBtn__lEM\\+c {
    width: 48px;
    height: 48px;
    font-size: 13px;
  }

  .FloatingLanguageSwitcher_optionsContainer__hiPqs {
    bottom: 60px;
  }

  .FloatingLanguageSwitcher_optionBtn__459D3 {
    width: 100px;
    height: 40px;
    padding: 0 10px;
  }
}

/* Very Small Mobile */
@media (max-width: 360px) {
  .FloatingLanguageSwitcher_floatingContainer__Tu5Lm {
    bottom: 12px;
    left: 12px;
  }

  .FloatingLanguageSwitcher_mainBtn__lEM\\+c {
    width: 45px;
    height: 45px;
    font-size: 12px;
  }

  .FloatingLanguageSwitcher_optionsContainer__hiPqs {
    bottom: 55px;
  }

  .FloatingLanguageSwitcher_optionBtn__459D3 {
    width: 95px;
    height: 38px;
    padding: 0 10px;
  }

  .FloatingLanguageSwitcher_optionLabel__dsVoI {
    font-size: 11px;
  }

  .FloatingLanguageSwitcher_optionCode__fHWdV {
    font-size: 9px;
  }
}

/* Accessibility */
.FloatingLanguageSwitcher_mainBtn__lEM\\+c:focus,
.FloatingLanguageSwitcher_optionBtn__459D3:focus {
  outline: none;
}

/* Print - Hide when printing */
@media print {
  .FloatingLanguageSwitcher_floatingContainer__Tu5Lm {
    display: none;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Components/Langauges/FloatingLanguageSwitcher.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;4CAC0C;EAC1C,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D;;4CAE0C;EAC1C,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,wBAAwB;EACxB;6CAC2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D;;6CAE2C;EAC3C,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,iDAAiD;EACjD,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB;uCACqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;qBAGmB;EACnB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,sCAAsC;EACtC;4CAC0C;EAC1C,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB;4CAC0C;AAC5C;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB;4CAC0C;EAC1C,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,2DAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf;+CAC2C;EAC7C;;EAEA;IACE;8CAC0C;EAC5C;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,kBAAkB;AAClB;;EAEE,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".floatingContainer {\n  position: fixed;\n  bottom: 30px;\n  left: 30px;\n  z-index: 9999;\n}\n\n/* Main Button - with glow */\n.mainBtn {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #1a5f3f 0%, #0f4229 100%);\n  color: white;\n  border: none;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.4),\n              0 0 20px rgba(26, 95, 63, 0.3);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 10001;\n}\n\n.mainBtn:hover {\n  background: linear-gradient(135deg, #0f4229 0%, #082917 100%);\n  box-shadow: 0 6px 16px rgba(26, 95, 63, 0.5),\n              0 0 30px rgba(26, 95, 63, 0.5),\n              0 0 40px rgba(26, 95, 63, 0.3);\n  transform: scale(1.08);\n  cursor: pointer;\n}\n\n.mainBtn.open {\n  background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);\n  transform: rotate(90deg);\n  box-shadow: 0 4px 12px rgba(211, 47, 47, 0.4),\n              0 0 20px rgba(211, 47, 47, 0.3);\n}\n\n.mainBtn.open:hover {\n  background: linear-gradient(135deg, #b71c1c 0%, #8b0000 100%);\n  box-shadow: 0 6px 16px rgba(211, 47, 47, 0.5),\n              0 0 30px rgba(211, 47, 47, 0.5),\n              0 0 40px rgba(211, 47, 47, 0.3);\n  cursor: pointer;\n}\n\n/* Options Container */\n.optionsContainer {\n  position: absolute;\n  bottom: 70px;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(20px);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  pointer-events: none;\n  z-index: 1000;\n}\n\n.optionsContainer.visible {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n  pointer-events: all;\n}\n\n/* Option Buttons - ENHANCED with micro-interactions */\n.optionBtn {\n  width: 120px;\n  height: 48px;\n  border-radius: 24px;\n  background: white;\n  border: 2px solid #1a5f3f;\n  color: #1a5f3f;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1),\n              0 0 0 rgba(26, 95, 63, 0);\n  font-weight: 600;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Animated background effect on hover (shimmer sweep) */\n.optionBtn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, \n    transparent 0%, \n    rgba(26, 95, 63, 0.1) 50%, \n    transparent 100%);\n  transition: left 0.5s ease;\n  z-index: 0;\n}\n\n.optionBtn:hover::before {\n  left: 100%;\n}\n\n.optionBtn:hover {\n  background: rgba(26, 95, 63, 0.05);\n  border-color: #0f4229;\n  transform: translateX(8px) scale(1.05);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15),\n              0 0 20px rgba(26, 95, 63, 0.3);\n  cursor: pointer;\n}\n\n/* Animate the label on hover */\n.optionBtn:hover .optionLabel {\n  transform: translateX(-2px);\n  color: #0f4229;\n}\n\n/* Animate the code on hover */\n.optionBtn:hover .optionCode {\n  transform: scale(1.15);\n  opacity: 1;\n}\n\n.optionBtn.active {\n  background: linear-gradient(135deg, #1a5f3f 0%, #0f4229 100%);\n  color: white;\n  border-color: #1a5f3f;\n  box-shadow: 0 2px 8px rgba(26, 95, 63, 0.3),\n              0 0 15px rgba(26, 95, 63, 0.2);\n}\n\n/* Active state shouldn't show the sweep effect */\n.optionBtn.active::before {\n  display: none;\n}\n\n.optionBtn.active:hover {\n  background: linear-gradient(135deg, #0f4229 0%, #082917 100%);\n  border-color: #0f4229;\n  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.4),\n              0 0 25px rgba(26, 95, 63, 0.4);\n  cursor: pointer;\n  transform: translateX(8px) scale(1.05);\n}\n\n.optionLabel {\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  position: relative;\n  z-index: 1;\n}\n\n.optionCode {\n  font-size: 12px;\n  font-weight: 700;\n  opacity: 0.8;\n  transition: all 0.3s ease;\n  position: relative;\n  z-index: 1;\n}\n\n/* Backdrop */\n.backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.2);\n  z-index: 998;\n  animation: fadeIn 0.3s ease;\n  cursor: pointer;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Tablet Responsive */\n@media (max-width: 1024px) {\n  .floatingContainer {\n    bottom: 25px;\n    left: 25px;\n  }\n\n  .mainBtn {\n    width: 52px;\n    height: 52px;\n    font-size: 15px;\n  }\n\n  .optionBtn {\n    width: 110px;\n    height: 44px;\n    padding: 0 14px;\n  }\n\n  .optionLabel {\n    font-size: 13px;\n  }\n\n  .optionCode {\n    font-size: 11px;\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .floatingContainer {\n    bottom: 20px;\n    left: 20px;\n  }\n\n  .mainBtn {\n    width: 50px;\n    height: 50px;\n    font-size: 14px;\n    box-shadow: 0 3px 10px rgba(26, 95, 63, 0.4),\n                0 0 15px rgba(26, 95, 63, 0.25);\n  }\n\n  .mainBtn:hover {\n    box-shadow: 0 4px 12px rgba(26, 95, 63, 0.5),\n                0 0 25px rgba(26, 95, 63, 0.4);\n  }\n\n  .optionsContainer {\n    bottom: 65px;\n  }\n\n  .optionBtn {\n    width: 105px;\n    height: 42px;\n    padding: 0 12px;\n    border-radius: 21px;\n  }\n\n  .optionLabel {\n    font-size: 12px;\n  }\n\n  .optionCode {\n    font-size: 10px;\n  }\n}\n\n/* Small Mobile */\n@media (max-width: 480px) {\n  .floatingContainer {\n    bottom: 15px;\n    left: 15px;\n  }\n\n  .mainBtn {\n    width: 48px;\n    height: 48px;\n    font-size: 13px;\n  }\n\n  .optionsContainer {\n    bottom: 60px;\n  }\n\n  .optionBtn {\n    width: 100px;\n    height: 40px;\n    padding: 0 10px;\n  }\n}\n\n/* Very Small Mobile */\n@media (max-width: 360px) {\n  .floatingContainer {\n    bottom: 12px;\n    left: 12px;\n  }\n\n  .mainBtn {\n    width: 45px;\n    height: 45px;\n    font-size: 12px;\n  }\n\n  .optionsContainer {\n    bottom: 55px;\n  }\n\n  .optionBtn {\n    width: 95px;\n    height: 38px;\n    padding: 0 10px;\n  }\n\n  .optionLabel {\n    font-size: 11px;\n  }\n\n  .optionCode {\n    font-size: 9px;\n  }\n}\n\n/* Accessibility */\n.mainBtn:focus,\n.optionBtn:focus {\n  outline: none;\n}\n\n/* Print - Hide when printing */\n@media print {\n  .floatingContainer {\n    display: none;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"floatingContainer": `FloatingLanguageSwitcher_floatingContainer__Tu5Lm`,
	"mainBtn": `FloatingLanguageSwitcher_mainBtn__lEM+c`,
	"open": `FloatingLanguageSwitcher_open__pN0X0`,
	"optionsContainer": `FloatingLanguageSwitcher_optionsContainer__hiPqs`,
	"visible": `FloatingLanguageSwitcher_visible__9i3Dn`,
	"optionBtn": `FloatingLanguageSwitcher_optionBtn__459D3`,
	"optionLabel": `FloatingLanguageSwitcher_optionLabel__dsVoI`,
	"optionCode": `FloatingLanguageSwitcher_optionCode__fHWdV`,
	"active": `FloatingLanguageSwitcher_active__+dIA9`,
	"backdrop": `FloatingLanguageSwitcher_backdrop__BS1rO`,
	"fadeIn": `FloatingLanguageSwitcher_fadeIn__8t7Aq`
};
export default ___CSS_LOADER_EXPORT___;
